import * as React from 'react';

type ContextMenuLinkProps = {
  href?: string;
  onNavigate: () => void;
  children: React.ReactNode;
  stopPropagation?: boolean;
  className?: string;
};

const shouldUseNativeNavigation = (e: React.MouseEvent<HTMLAnchorElement>) =>
  e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;

export const ContextMenuLink = ({
  href,
  onNavigate,
  children,
  stopPropagation = false,
  className
}: ContextMenuLinkProps) => {
  return (
    <a
      className={className}
      href={href}
      onClick={e => {
        if (stopPropagation) {
          e.stopPropagation();
        }
        if (shouldUseNativeNavigation(e)) {
          return;
        }
        e.preventDefault();
        onNavigate();
      }}
    >
      {children}
    </a>
  );
};
